/*!
 *
 *	phone-check.js
 *
 */

var phoneCheck = function(){
	var $tel = $('a[href^="tel:"]');
	if(　origin.ua.isMobile ){
		$tel.addClass('is_tel_enabled');
	}else{
		$tel.addClass('is_tel_disabled').on('tap', function(e){
			e.preventDefault();
		});
	};
};

module.exports = phoneCheck;



//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/phone-check.js
// module id = 14
// module chunks = 0